import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'ad-'

export default {
  path: '/ad',
  name: 'ad',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '广告管理',
      },
      component: () => import('@/views/ad/list'),
    },
  ],
}
